<template>
  <div class="relative">
    <h1
      class="flex flex-col items-center space-y-16 text-center font-medium md:space-y-20 lg:space-y-24 xl:space-y-28"
    >
      <span
        class="type-font-salt-ss02 text-[30px]/[1.1em] font-medium md:text-[50px]/[1.1em] xl:text-[60px]/[1.1em]"
        >wait! for more</span
      >
      <span class="large-text type-font-salt-ss02 text-charcoal -rotate-2"
        ><span>creativity</span></span
      >
    </h1>
    <div class="icons pointer-events-none absolute inset-0">
      <PayloadIcon
        class="text-yellow-light absolute bottom-[0.6em] left-[0.35em] h-[0.39em]"
        icon="SvgIconSun"
      />
      <PayloadIcon
        class="absolute bottom-[0.7em] left-[1.7em] h-[0.4em] -rotate-40 text-white"
        icon="SvgIconLightning"
      />
      <PayloadIcon
        class="text-purple absolute bottom-[0.9em] left-[3.55em] h-[0.4em]"
        icon="SvgIconPencil"
      />
      <PayloadIcon
        class="text-blue-dark absolute bottom-[-0.5em] left-[1.45em] h-[0.3em] rotate-16"
        icon="SvgIconBook"
      />
      <PayloadIcon
        class="text-green absolute bottom-[-0.5em] left-[3.25em] h-[0.45em]"
        icon="SvgIconLeaves"
      />
    </div>
  </div>
</template>

<style scoped>
@reference '#css';

span {
  @apply inline-block;
}
</style>
